import { isString } from 'lodash';

import i18n from 'src/locales/i18n';

import { jobsApi } from './jobs.service';
import { JobFilters } from './jobs.types';
import { ApplicationStage } from '../applications/applications.types';

export const generateJobLinkRequestError = (e: any) => {
  if (isString(e?.data?.error_code)) {
    if (e?.data.error_code === '1_4002') {
      return i18n.t('jobs.action.api.invalid_state');
    }

    if (e?.data.error_code === '1_4003') {
      return i18n.t('jobs.action.api.link_exists');
    }
  }
  return i18n.t('jobs.action.api.default_error');
};

export const updateJobApplicationStatus = (
  jobId: string,
  destinationColumnId: string,
  filters: JobFilters
) =>
  jobsApi.util.updateQueryData(
    'getMyActiveJobs',
    Object.values(filters).every((value) => !value) ? undefined : filters,
    (jobsResponse) => ({
      ...jobsResponse,
      results: jobsResponse.results.map((job) =>
        job.id === jobId
          ? { ...job, latest_application_status: destinationColumnId as ApplicationStage }
          : job
      ),
    }),
    true
  );

export const generateJobApplicationStatusUpdateError = (e: any) => {
  if (isString(e?.data?.error_code)) {
    if (e?.data.error_code === '2_0004') {
      return i18n.t('jobs.api.update_stage.is_linked');
    }
  }

  return i18n.t('jobs.api.update_stage.default_error');
};

export const generateArchiveJobError = (e: any) => {
  if (isString(e?.data?.error_code)) {
    if (e?.data.error_code === '2_0004') {
      return i18n.t('jobs.api.archive.linked');
    }
  }
  return i18n.t('jobs.api.archive.default_error');
};

export const generateCreateJobError = (e: any) => {
  if (isString(e?.data?.error_code)) {
    if (e?.data.error_code === '14_0001') {
      return i18n.t('jobs.api.create.scrape_failed');
    }
  }
  return i18n.t('jobs.api.create.default_error');
};
